module.exports = __webpack_public_path__ + "static/media/Money.691e5c65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/Money.svg
// module id = 146
// module chunks = 0